<template>
  <div class="estado-proceso">
    <Titulo titulo="Estado de procesos" />
    <b-row>
      <b-col cols="12" md="8">
        <div class="margin-lateral">
          <h3 class="color-secundary">Estado de procesos</h3>
          <p class="mb-4 text-justify">
            En esta sección encontrara el listado de todas las operaciones y el
            estado de cada una de ellas.
            <br />
            <br />- <b>En cola:</b> el archivo está pendiente de valoración
            <br />- <b>Procesando:</b> el archivo está en proceso, por favor
            esté pendiente de la confirmación <br />- <b>Finalizado:</b> el
            archivo fue validado y cargado
            <br />
          </p>
        </div>
      </b-col>
      <!-- Panel Derecho -->
      <!--BannerRight/-->
    </b-row>
    <!-- mostramos la tabla -->
    <div style="margin: 0% 8% 5% 9.5% !important">
      <table-component
        :data="TablaEstadoProceso.datos"
        @click-event="clickEvent"
        :perPage="perPage"
        :dataLength="TablaEstadoProceso.paginacion.total"
        pagination
        filtro
        :SetectFiltro="dataFilter"
        showSelectFiltro
        showFilterDates
        @click-buscar="buscar"
      >
        <table-column
          slot="label"
          :label="'Proceso'"
          v-bind:value="'proceso'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Archivo'"
          v-bind:value="'archivo'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Fecha de inicio'"
          v-bind:value="'fecha_inicio'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Estado'"
          v-bind:value="'estado'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Total registros'"
          v-bind:value="'total_registros'"
          :filter="'numeric'"
          :customClass="'text-right'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Resgistros correctos'"
          v-bind:value="'registros_correctos'"
          :filter="'numeric'"
          :customClass="'text-right'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Registros incorrectos'"
          v-bind:value="'registros_incorrectos'"
          :filter="'numeric'"
          :customClass="'text-right'"
        ></table-column>
        <table-column
          slot="label"
          :label="'Porcentaje completado'"
          v-bind:value="'porcentaje'"
          :filter="'percentage'"
          :customClass="'text-right'"
        ></table-column>
        <table-column slot="label" :label="'Descargar log'" :icon="'fa'">
          <template
            slot="icon"
            :icon="'fa fa-download'"
            :class="'btn btn-sm btn-info'"
            :slug="'Descargar'"
            :tooltip="'Descargar Log'"
            :customActive="buttonsActives"
            :loading="false"
          ></template>
        </table-column>
      </table-component>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectNovedad from "@/data/SelectQueEsNovedad.json";
import SelectTipoNovedad from "@/data/SelectTipoNovedad.json";
import FileSaver from "file-saver";

export default {
  name: "EstadoProcesos",
  data() {
    return {
      SelectNovedad: SelectNovedad,
      SelectTipoNovedad: SelectTipoNovedad,
      selectQueEsNovedad: "",
      selectTipoNovedad: "null",
      fecha_hora_inicio: this.$moment()
        .startOf("month")
        .format("YYYY-MM-DD 00:00:00"),
      fecha_hora_fin: this.$moment(new Date()).format("YYYY-MM-DD 23:59:59"),
      buttonsActives: ["finalizado", "rechazado", "pendiente de revision"],
      perPage: 50,
      reload: 1,
    };
  },
  computed: {
    ...mapGetters({
      TablaEstadoProceso: "pages/tablaEstadoProceso",
      loading: "loading",
      reloaded: "pages/reload",
    }),
    dataFilter() {
      return [
        { value: null, text: "Todos los cargues", disabled: true },
        { value: "cargue_garantia", text: "Cargue de Registros" },
        { value: "cargue_novaciones", text: "Cargue de Novaciones por Plazo" },
        {
          value: "cargue_novaciones_v2",
          text: "Cargue de Novaciones por Saldo",
        },
        {
          value: "cargue_novaciones_v3",
          text: "Cargue de Novaciones por Saldos 2",
        },
        { value: "cargue_cartera", text: "Cargue de Cartera" },
        { value: "cargue_renovaciones", text: "Cargue de Renovaciones" },
        { value: "cargue_renovaciones", text: "Cargue de Refinanciaciones" },
        { value: "cargue_utilizaciones", text: "Cargue de Utilizaciones" },
        {
          value: "cargue_reclamaciones_parciales",
          text: "Cargue de Reclamaciones Parciales",
        },
        {
          value: "cargue_reclamaciones_totales",
          text: "Cargue de Reclamaciones Totales",
        },
        { value: "cargue_preaprobados", text: "Cargue de Preaprobados" },
        {
          value: "cargue_reestructuraciones",
          text: "Cargue de Reestructuraciones",
        },
        {
          value: "cargue_no_garantizados",
          text: "Cargue de No Garantizados",
        },
        {
          value: "venta_cartera",
          text: "Cargue venta de cartera",
        },
      ]; // Pendiente mostrar solo los cargues que tiene activos. Evaluar una consulta que agrupe por tipo de cargue.

      //return [... new Set(this.TablaEstadoProceso.datos.map(x => x.proceso))];
    },
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    BannerRight: () => import("@/containers/layout/banner-right.vue"),
    FilterTable: () => import("@/components/table/FilterTable"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  methods: {
    index(page = 1, paginar = true) {
      if (this.selectTipoNovedad === null) {
        this.selectTipoNovedad = "null";
      }
      this.$store.dispatch("pages/fetchEstadoProceso", {
        endpoint: "informes/estado_proceso",
        params: {
          fecha_inicio: this.fecha_hora_inicio,
          fecha_fin: this.fecha_hora_fin,
          tipo_cargue: this.selectTipoNovedad,
          row: this.perPage,
          page: page,
          paginar: paginar,
        },
      });
    },
    clickEvent(evento, name) {
      switch (name) {
        case "paginacion":
          this.perPage = evento.nRows;
          this.index(evento.page, evento.SetectFiltro);
          break;
        case "Descargar":
          this.$store.commit("SET_LOADING", true);
          let descarga_log = new Promise((res, rej) => {
            this.$store.getters.api
              .get("portal/proceso/" + evento.archivo.split(".")[0])
              .then((response) => {
                FileSaver.saveAs(
                  new Blob([response.data], { type: "text/csv;charset=utf-8" }),
                  evento.archivo.split(".")[0] + ".csv"
                );
                res();
              })
              .catch((error) => {
                rej(error);
              });
          });

          descarga_log
            .then(() => {
              let toast = this.$toasted.show(
                "Archivo de log descargado con éxito",
                {
                  theme: "toasted-primary",
                  position: "bottom-right",
                  duration: 5000,
                }
              );
            })
            .catch((error) => {
              console.log(error);
              let toast = this.$toasted.show(
                "Error intentando descargar el archivo",
                {
                  theme: "toasted-primary",
                  position: "bottom-right",
                  duration: 5000,
                }
              );
            })
            .then(() => {
              this.$store.commit("SET_LOADING", false);
            });
          break;
      }
    },
    buscar(params) {
      this.fecha_hora_inicio = params.fecha_inicio;
      this.fecha_hora_fin = params.fecha_fin;
      this.encabezados = params.encabezados;
      this.selectTipoNovedad = params.filterSelected;
      this.index();
    },
  },
  mounted() {
    this.index(1);
    this.TablaEstadoProceso;

    if (!localStorage.reload_proceso) {
      location.reload();
      localStorage.reload_proceso = 1;
    }
  },
};
</script>